import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MaterialModal from '@material-ui/core/Modal';

const useStyles = makeStyles({
  paper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    backgroundColor: '#fff',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    borderRadius: '25px'
  },
  invisible: {
    visibility: 'hidden'
  }
});

interface ModalProps {
  isOpen: boolean;
  closeModalFunc: (val: boolean) => void;
  ariaLabel?: string;
  ariaDescription?: string;
  children: any;
  disableBackdropClick?: boolean;
  disableEscapeKeyDown?: boolean;
  disableEnforceFocus?: boolean;
  isInvisible?: boolean;
}

const Modal = ({
  isOpen,
  closeModalFunc,
  ariaLabel,
  ariaDescription,
  children,
  disableBackdropClick = false,
  disableEscapeKeyDown = false,
  disableEnforceFocus = false,
  isInvisible = false
}: ModalProps) => {
  const classes = useStyles();

  return (
    <MaterialModal
      aria-labelledby={ariaLabel}
      aria-describedby={ariaDescription}
      open={isOpen}
      onClose={(_e, reason: string) => {
        if (disableBackdropClick && reason === 'backdropClick') return;
        closeModalFunc(true);
      }}
      disableEscapeKeyDown={disableEscapeKeyDown}
      disableEnforceFocus={disableEnforceFocus}
    >
      <div
        className={`${classes.paper} ${isInvisible ? classes.invisible : ''}`}
      >
        {children}
      </div>
    </MaterialModal>
  );
};

export default Modal;
